import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { commonMessages } from 'src/utils/messages';
import { servicePlansMessages } from 'src/features/servicePlans/utils/messages';
import { ServicePlanCategoryFormSchemaValues } from 'src/features/servicePlanCategory/utils/formSchema';

type ServicePlanCategoryFormProps = {
    form: UseFormReturn<ServicePlanCategoryFormSchemaValues>;
    onSubmit: (values: ServicePlanCategoryFormSchemaValues) => void;
};

function ServicePlanCategoryForm({ onSubmit, form }: ServicePlanCategoryFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ServicePlanCategoryFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(commonMessages.name)}
            />
            <InputFormField<ServicePlanCategoryFormSchemaValues>
                form={form}
                name="code"
                label={formatMessage(servicePlansMessages.code)}
            />
        </Form>
    );
}

export default ServicePlanCategoryForm;
